export const translation = {
  zenit: {
    ae: {
      siteTitle: "مكافآتك | Zenit",
      btnSignup: "سجّل",
      title: "مكافأة",
      subtitle: " 100% ",
      text: " من قيمة أول إيداعاتك حتى مبلغ 400$",
      btnGetBonus: "احصل على مكافأة",
      bkString: "المراهنات Zenit",
      rightString: "جميع الحقوق محفوظة",
      rules: "الشروط والأحكام"
    },
    bn: {
      siteTitle: "আপনার বোনাস | Zenit",
      btnSignup: "নিবন্ধন করুন",
      title: "বোনাস",
      subtitle: "100%",
      text: "আপনার প্রথম জমার 400$ পর্যন্ত",
      btnGetBonus: "বোনাস পান",
      bkString: "বুকমেকার Zenit",
      rightString: "সর্বস্বত্ব সংরক্ষিত",
      rules: "শর্তাবলী"
    },
    br: {
      siteTitle: "Seus bônus | Zenit",
      btnSignup: "REGISTRE-SE",
      title: "BÔNUS",
      subtitle: "100%",
      text: `DO SEU PRIMEIRO
        DEPÓSITO ATÉ 400$`,
      btnGetBonus: "OBTENHA UM BÔNUS",
      bkString: "Casa de Apostas Zenit",
      rightString: "Todos os direitos reservados",
      rules: "regras"
    },
    de: {
      siteTitle: "Ihre Boni | Zenit",
      btnSignup: "REGISTRIEREN",
      title: "BONUS",
      subtitle: "100%",
      text: "IHRER ERSTEN EINZAHLUNG BIS ZU 350€",
      btnGetBonus: "BONUS ERHALTEN",
      bkString: "Buchmacher Zenitbet",
      rightString: " Alle Rechte vorbehalten",
      rules: "ALLGEMEINE GESCHÄFTSBEDINGUNGEN"
    },
    en: {
      siteTitle: "Your bonuses | Zenit",
      btnSignup: "REGISTER",
      title: "BONUS",
      subtitle: "100%",
      text: "OF YOUR FIRST DEPOSIT UP TO 400$",
      btnGetBonus: "GET BONUS",
      bkString: "BOOKMAKER ZENIT",
      rightString: "ALL RIGHTS RESERVED",
      rules: "rules"
    },
    fr: {
      siteTitle: "Vos bonus | Zenit",
      btnSignup: "S'ENREGISTRER",
      title: "BONUS",
      subtitle: "100%",
      text: "DE VOTRE PREMIER DÉPÔT JUSQU'À 350€",
      btnGetBonus: "OBTENIR UN BONUS",
      bkString: "Bookmaker Zenitbet",
      rightString: "Tous droits réservés",
      rules: "CONDITIONS GÉNÉRALES"
    },
    ir: {
      siteTitle: "بیش از ۱۰۰ درصدِ واریز شما | بنگاه شرط‌بندی ZENIT",
      btnSignup: "ثبت‌نام",
      title: "پاداش اولین واریز",
      subtitle: "100%",
      text: "حداکثر تا  400$",
      btnGetBonus: "دریافت پاداش",
      bkString: "بنگاه شرط‌بندی Zenit",
      rightString: "همه حقوق محفوظ است",
      rules: "قوانین"
    },
    kz: {
      siteTitle: "Сенің бонустарың | БК Zenit",
      btnSignup: "ТІРКЕЛУ",
      title: "Бонус",
      subtitle: "100%",
      text: "алғашқы толықтыруға 170000Т дейін",
      btnGetBonus: "Бонусты алу",
      bkString: "Зенит букмекерлік кеңсесі",
      rightString: "Барлық құқық қорғалған",
      rules: "ЕРЕЖЕЛЕР",
      regFormTitle: "Тіркелу бонусты алу!",
    },
    mx: {
      siteTitle: "Sus bonificaciones | Zenit",
      btnSignup: "REGISTRAR",
      title: "BONIFICACIÓN",
      subtitle: "100%",
      text: " DE SU PRIMER DEPÓSITO HASTA 400$",
      btnGetBonus: "OBTENHA UM BÔNUS",
      bkString: "Zenit Bookmakers",
      rightString: "Todos los derechos reservados",
      rules: "TÉRMINOS Y CONDICIONES"
    },
    ru: {
      siteTitle: "Забери бонус до 30 000 в ZENIT",
      btnSignup: "Зарегистрироваться",
      title: "Бонус",
      subtitle: "100%",
      text: "на первое пополнение до 30000₽",
      btnGetBonus: "Получить бонус",
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      rules: "ПРАВИЛА",
      regFormTitle: "зарегистрируйся и получи бонус!",
    },
    sw: {
      siteTitle: "Bonasi zako | Zenit",
      btnSignup: "JISAJILI",
      title: "BONASI",
      subtitle: "100%",
      text: `ZA PESA ZA KWANZA UNAZOWEKA 
        HADI KIASI CHA 400$`,
      btnGetBonus: "POKEA BONASI",
      bkString: "Alamisho Zenit",
      rightString: "Haki zote zimehifadhiwa",
      rules: "SHERIA NA MASHARTI"
    },
    tm: {
      siteTitle: "100% бонус за пополнение | БК ZENIT",
      btnSignup: "Зарегистрироваться",
      title: "Бонус",
      subtitle: "100%",
      text: "на первое пополнение до 100 манат",
      btnGetBonus: "Получить бонус",
      bkString: "Букмекерская контора Зенит",
      rightString: "Все права защищены",
      rules: "ПРАВИЛА"
    },
    tr: {
      siteTitle: "Bonuslarınız | Zenit",
      btnSignup: "KAYDOLUN",
      title: "BONUS",
      subtitle: "+% 100'Ü",
      text: "400$ KADAR ILK YATIRDIĞINIZ PARANIN",
      btnGetBonus: "BONUS AL",
      bkString: " Zenit Bahis Şirketi",
      rightString: "Tüm hakları saklıdır",
      rules: "HÜKÜM VE KOŞULLAR"
    },
    uz: {
      siteTitle: "Bonuslaring | Zenit",
      btnSignup: "QOIDALAR",
      title: "BONUS",
      subtitle: " 100% ",
      text: " 30000₽ GACHA BIRINCHI TO‘LDIRISHGA",
      btnGetBonus: "BONUS OLISH",
      bkString: "Zenit bukmekerlik kontorasi",
      rightString: "Barcha huquqlar himoya qilinadi",
      rules: "QOIDALAR"
    },
    vi: {
      siteTitle: "Tiền thưởng của bạn | Zenit",
      btnSignup: "ĐĂNG KÝ",
      title: "TIỀN THƯỞNG",
      subtitle: "100%",
      text: `TRONG LẦN NẠP TIỀN 
        ĐẦU TIÊN LÊN ĐẾN 400$`,
      btnGetBonus: "NHẬN TIỀN THƯỞNG",
      bkString: "Nhà cái Zenit",
      rightString: "Bảo lưu mọi quyền",
      rules: "ĐIỀU KHOẢN VÀ ĐIỀU KIỆN"
    }
  },
  zenbet: {
    ae: {
      siteTitle: "مكافآتك | «ZENBET»",
      btnSignup: "سجّل",
      title: "مكافأة",
      subtitle: " 100% ",
      text: " من قيمة أول إيداعاتك حتى مبلغ 400$",
      btnGetBonus: "احصل على مكافأة",
      bkString: "المراهنات «ZENBET»",
      rightString: "جميع الحقوق محفوظة",
      rules: "الشروط والأحكام"
    },
    bn: {
      siteTitle: "আপনার বোনাস | «ZENBET»",
      btnSignup: "নিবন্ধন করুন",
      title: "বোনাস",
      subtitle: "100%",
      text: "আপনার প্রথম জমার 400$ পর্যন্ত",
      btnGetBonus: "বোনাস পান",
      bkString: "বুকমেকার «ZENBET»",
      rightString: "সর্বস্বত্ব সংরক্ষিত",
      rules: "শর্তাবলী"
    },
    br: {
      siteTitle: "Seus bônus | «ZENBET»",
      btnSignup: "REGISTRE-SE",
      title: "BÔNUS",
      subtitle: "100%",
      text: `DO SEU PRIMEIRO
        DEPÓSITO ATÉ 400$`,
      btnGetBonus: "OBTENHA UM BÔNUS",
      bkString: "Casa de Apostas «ZENBET»",
      rightString: "Todos os direitos reservados",
      rules: "regras",
      regFormTitle: "Registre-se OBTENHA UM BÔNUS!",
    },
    de: {
      siteTitle: "Ihre Boni | «ZENBET»",
      btnSignup: "REGISTRIEREN",
      title: "BONUS",
      subtitle: "100%",
      text: "IHRER ERSTEN EINZAHLUNG BIS ZU 350 €",
      btnGetBonus: "BONUS ERHALTEN",
      bkString: "Buchmacher «ZENBET»",
      rightString: " Alle Rechte vorbehalten",
      rules: "ALLGEMEINE GESCHÄFTSBEDINGUNGEN"
    },
    en: {
      siteTitle: "Your bonuses | «ZENBET»",
      btnSignup: "REGISTER",
      title: "BONUS",
      subtitle: "100%",
      text: "OF YOUR FIRST DEPOSIT UP TO 400$",
      btnGetBonus: "GET BONUS",
      bkString: "BOOKMAKER «ZENBET»",
      rightString: "ALL RIGHTS RESERVED",
      rules: "rules"
    },
    fr: {
      siteTitle: "Vos bonus | «ZENBET»",
      btnSignup: "S'ENREGISTRER",
      title: "BONUS",
      subtitle: "100%",
      text: "DE VOTRE PREMIER DÉPÔT JUSQU'À 350€",
      btnGetBonus: "OBTENIR UN BONUS",
      bkString: "Bookmaker «ZENBET»",
      rightString: "Tous droits réservés",
      rules: "CONDITIONS GÉNÉRALES"
    },
    ir: {
      siteTitle: "بیش از ۱۰۰ درصدِ واریز شما | بنگاه شرط‌بندی «ZENBET»",
      btnSignup: "ثبت‌نام",
      title: "پاداش اولین واریز",
      subtitle: "100%",
      text: "حداکثر تا 400$",
      btnGetBonus: "دریافت پاداش",
      bkString: "بنگاه شرط‌بندی «ZENBET»،",
      rightString: "همه حقوق محفوظ است",
      rules: "قوانین"
    },
    kz: {
      siteTitle: "Сенің бонустарың | БК «ZENBET»",
      btnSignup: "ТІРКЕЛУ",
      title: "Бонус",
      subtitle: "100%",
      text: "алғашқы толықтыруға 170000Т дейін",
      btnGetBonus: "Бонусты алу",
      bkString: "«ZENBET»  букмекерлік кеңсесі",
      rightString: "Барлық құқық қорғалған",
      rules: "ЕРЕЖЕЛЕР"
    },
    mx: {
      siteTitle: "Sus bonificaciones | «ZENBET»",
      btnSignup: "REGISTRAR",
      title: "BONIFICACIÓN",
      subtitle: "100%",
      text: " DE SU PRIMER DEPÓSITO HASTA 400$",
      btnGetBonus: "OBTENHA UM BÔNUS",
      bkString: "«ZENBET» Bookmakers",
      rightString: "Todos los derechos reservados",
      rules: "TÉRMINOS Y CONDICIONES"
    },
    ru: {
      siteTitle: "Твои бонусы | Букмекерская контора «ZENBET»",
      btnSignup: "Зарегистрироваться",
      title: "Бонус",
      subtitle: "100%",
      text: "на первое пополнение до 30000₽",
      btnGetBonus: "Получить бонус",
      bkString: "Букмекерская контора «ZENBET»",
      rightString: "Все права защищены",
      rules: "ПРАВИЛА"
    },
    sw: {
      siteTitle: "Bonasi zako | «ZENBET»",
      btnSignup: "JISAJILI",
      title: "BONASI",
      subtitle: "100%",
      text: `ZA PESA ZA KWANZA UNAZOWEKA 
        HADI KIASI CHA 400$`,
      btnGetBonus: "POKEA BONASI",
      bkString: "Alamisho «ZENBET»",
      rightString: "Haki zote zimehifadhiwa",
      rules: "SHERIA NA MASHARTI"
    },
    tr: {
      siteTitle: "Bonuslarınız | «ZENBET»",
      btnSignup: "KAYDOLUN",
      title: "BONUS",
      subtitle: "+% 100'Ü",
      text: "400$ KADAR ILK YATIRDIĞINIZ PARANIN",
      btnGetBonus: "BONUS AL",
      bkString: " «ZENBET» Bahis Şirketi",
      rightString: "Tüm hakları saklıdır",
      rules: "HÜKÜM VE KOŞULLAR"
    },
    uz: {
      siteTitle: "Bonuslaring | «ZENBET»",
      btnSignup: "QOIDALAR",
      title: "BONUS",
      subtitle: " 100% ",
      text: " 30000₽ GACHA BIRINCHI TO‘LDIRISHGA",
      btnGetBonus: "BONUS OLISH",
      bkString: "«ZENBET» bukmekerlik kontorasi",
      rightString: "Barcha huquqlar himoya qilinadi",
      rules: "QOIDALAR"
    },
    vi: {
      siteTitle: "Tiền thưởng của bạn | «ZENBET»",
      btnSignup: "ĐĂNG KÝ",
      title: "TIỀN THƯỞNG",
      subtitle: "100%",
      text: `TRONG LẦN NẠP TIỀN 
        ĐẦU TIÊN LÊN ĐẾN 400$`,
      btnGetBonus: "NHẬN TIỀN THƯỞNG",
      bkString: "Nhà cái «ZENBET»",
      rightString: "Bảo lưu mọi quyền",
      rules: "ĐIỀU KHOẢN VÀ ĐIỀU KIỆN"
    }
  }
}